import React from "react";
export default function Footer() {
  return (
    <footer className="mt-20 border-t border-white/5 bg-[#0A0A0A] text-gray-500 text-sm py-12 px-6 lg:px-12">
      <div className="max-w-[1600px] mx-auto">
        <p className="mb-6 text-gray-400">Questions? Call us at <span className="text-white">1-800-CINE-ONE</span></p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
          <div className="space-y-3">
            <a href="#" className="block hover:text-white">FAQ</a>
            <a href="#" className="block hover:text-white">Investor Relations</a>
            <a href="#" className="block hover:text-white">Privacy</a>
          </div>
          <div className="space-y-3">
            <a href="#" className="block hover:text-white">Help Center</a>
            <a href="#" className="block hover:text-white">Jobs</a>
            <a href="#" className="block hover:text-white">Cookie Preferences</a>
          </div>
          <div className="space-y-3">
            <a href="#" className="block hover:text-white">Account</a>
            <a href="#" className="block hover:text-white">Ways to Watch</a>
            <a href="#" className="block hover:text-white">Corporate Information</a>
          </div>
          <div className="space-y-3">
            <a href="#" className="block hover:text-white">Media Center</a>
            <a href="#" className="block hover:text-white">Terms of Use</a>
            <a href="#" className="block hover:text-white">Contact Us</a>
          </div>
        </div>
        <p className="text-xs">© 2026 CineCinema. A sample Netflix-style streaming app.</p>
      </div>
    </footer>
  );
}
